import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';
import {DeviceDetectorService} from "ngx-device-detector";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import notify from "devextreme/ui/notify";
import { Breadcrumb, EditPassword, ReportService } from './report.service';
import { timestamp } from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent  implements OnInit {

  type: string;
  buscarTxt: string;
  buscarSw: boolean;
  _auth: boolean = false;
  loadingVisible: boolean;
  password: string;
  newPassword: string;
  popupVisible: boolean;
  hiddenReport: boolean;
  showAppData: boolean;
  hiddenAppData: boolean;
  urlData: string;
  showProjectData: boolean;
  hiddenProjectData: boolean;
  urlDataProject: any;
  breadcrumbs: Breadcrumb[] = [];
  selectBoxOptions: any;
  popupBuscarVisible: boolean;
  dataSource: any = [];
  loadIndicatorVisible: boolean;
  pdfSrc: SafeUrl ;
  productTypes: any[] = [{
    id: "1",
    name: "",
    icon: "user",
    items: [{
        id: "1_1",
        name: "Cambiar contraseña",
    }, {
        id: "1_2",
        name: "Salir",
    }]
  }];
  tabs: any = [
    {
      text: 'Proyectos de Inversión Pública'
    }, {
      text: 'Financiamiento Externo'
    }
  ];
  selectedIndex: number = 0;

  tipoEntidades:any;
  entidades:any;
  gestiones:any;
  proyectos:any;
  tipoEntidad: string='';
  entidad: string='';
  gestion: string= '2021';
  buscarSwGeneral: boolean;
  proyectosGeneral:any;
  boton1:string='normal';
  boton2:string='normal';
  departamentos=[
    {cod_departamento:'1', departamento:'CHUQUISACA'},
    {cod_departamento:'2', departamento:'LA PAZ'},
    {cod_departamento:'3', departamento:'COCHABAMBA'},
    {cod_departamento:'4', departamento:'ORURO'},
    {cod_departamento:'5', departamento:'POTOSI'},
    {cod_departamento:'6', departamento:'TARIJA'},
    {cod_departamento:'7', departamento:'SANTA CRUZ'},
    {cod_departamento:'8', departamento:'BENI'},
    {cod_departamento:'9', departamento:'PANDO'},
    {cod_departamento:'10', departamento:'NACIONAL'},
  ];
  departamento:string=''
  reportePopupVisible: boolean;
  listaReportes
  elemento

  constructor(private service: ReportService, private route: ActivatedRoute, public sanitizer: DomSanitizer, private deviceService: DeviceDetectorService , private router: Router) {
    this.filtrar();
    this.filtrarGeneral();
  }

  ngOnInit(): void {
    this.hiddenReport = false;
    let qs = document.querySelectorAll('.slide-up');
    qs[0]['style'].display = "none";
    let qs1 = document.querySelectorAll('.main-bar');
    qs1[0]['style'].display = "none";
    let qs2 = document.querySelectorAll('.breadcrumb-row');
    //qs2[0]['style'].display = "none";
    let qs4;
    setInterval(() => {
      qs4 = document.querySelectorAll('.site-footer');
      if(qs4 != undefined) {
        qs4[0]['style'].display = "none";
      }
    }, 200);

    const itemStr = localStorage.getItem('auth');
  	if (!itemStr) {
	  	this._auth = false;
	  } else {
      const item = JSON.parse(itemStr);
      const now = Math.floor(Date.now() / 1000);
      if (now > item.expiry) {
        localStorage.removeItem('auth');
        this._auth = false;
      } else {
        this._auth = true;
      }
    }
    this.selectBoxOptions = {
      width: 50,
      items: this.productTypes,
      displayExpr: 'name',
      onItemClick: (args) => {
          switch(args.itemData.id) {
            case '1_1':
              this.changePassword();
              break;
            case '1_2':
              this.logout();
              break;
          }
      }
  };
    this.service.breadcrumbObserver().subscribe(response => {
      if(this.breadcrumbs.length<=2) {
        this.breadcrumbs.push(response);
      }

    });
    this.service.updateBreadcrumbsObserver().subscribe(response => {
      this.breadcrumbs = [];
      this.breadcrumbs = response;
    });
    this.service.updateBreadcrumbObserver().subscribe(response => {
      switch(response) {
        case 0:
            this.showAppData = false;
            this.showProjectData = false;
            this.hiddenReport = false;
            this.buscarSw = false;
            this.buscarSwGeneral = false;
            this.buscarTxt='';
          break;
        case 1:
            this.showProjectData = false;
            this.hiddenAppData = false;
          break;
      }
    });
    this.service.addBreadcrumb({name: 'Inicio', param: 0});
    this.service.getTipoEntidad().subscribe(res =>{
      this.tipoEntidades = res.data
    })
    this.service.getGestion().subscribe(res => {
      this.gestiones = res;
      const found = this.gestiones.find(element => element.tipo_dato == 'V');
      this.gestion = found.gestion;
    })
    this.reportePopupVisible = false;
  }
  filtraEntidades(e){
    this.entidad = '';
    this.entidades = [];
    const codigo = e.value
    if(codigo === null){
      this.tipoEntidad=''
      this.filtrar()
    }else {
      const item = this.tipoEntidades.filter(i => i.orden_reporte === e.value)[0];
      if(item){
        this.service.getEntidad(item.cod_tipo_entidad).subscribe((res: any) => {
          this.entidades = res.data

        });
      }
      this.filtrar()
    }
  }
  filtraGestiones(e){
    this.entidad = '';
    this.tipoEntidad = '';
    this.filtrar()
  }
  filtraDepartamentos(e){
    this.filtrarGeneral()
  }
  selectTab(e) {
    this.selectedIndex = e.itemIndex;
  }

  open2(url) {
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.popupBuscarVisible = true;
  }

  open3(reporte, tipo){
    const parametros = reporte.parametros.split(",");
    let url = '';
    parametros.map(param =>{
      url += `&${param}=${this.elemento[param]}`;
    });
    let enlace
    if(tipo == 'PDF'){
      enlace = reporte.url_reporte + url;
    } else {
      enlace = reporte.url_reporte_xls + url;
    }
    console.log(enlace)
    console.log(enlace)
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(enlace);
    this.popupBuscarVisible = true;

  }

  reporteModal(ele){
    this.reportePopupVisible = true;
    this.elemento = ele
  }

  reporteModalConListaReportes(ele,opcion){
    this.service.getListaReportesPorOpcion(opcion).then(data => {
      this.listaReportes = data.data;
      this.elemento = ele;
      this.reportePopupVisible = true;
    });

  }

  buscarKey(e) {
    if(e.event.keyCode==13) {
      this.filtrar()
    }
  }

  buscarKeyGeneral(e) {
    if(e.event.keyCode==13) {
      this.filtrarGeneral()
    }
  }

   isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== "";
}
  filtrar(){
    this.entidad = (this.entidad== null)?'':this.entidad;
    this.proyectos = new CustomStore({
      key: "OrderNumber",
      load:  (loadOptions: any) => {
          let params: HttpParams = new HttpParams();
          [
              "skip",
              "take",
              "requireTotalCount",
              "requireGroupCount",
              "sort",
              "filter",
              "totalSummary",
              "group",
              "groupSummary"
          ].forEach((i) => {
              if (i in loadOptions && this.isNotEmpty(loadOptions[i]))
                  params = params.set(i, JSON.stringify(loadOptions[i]));
          });
          const page = (Number(params.get('skip'))/Number(params.get('take')))+1;
          params = params.set('gestion', this.gestion);
          params = params.set('codTipoEntidad', this.tipoEntidad);
          params = params.set('codEntidad', this.entidad);
          params = params.set('texto', this.buscarTxt);
          params = params.set('page', page.toString());
          return this.service.getProyectos(params)

        }
    });
  }

  filtrarGeneral(){
    this.proyectosGeneral = new CustomStore({
      key: "OrderNumber",
      load:  (loadOptions: any) => {
          let params: HttpParams = new HttpParams();
          [
              "skip",
              "take",
              "requireTotalCount",
              "requireGroupCount",
              "sort",
              "filter",
              "totalSummary",
              "group",
              "groupSummary"
          ].forEach((i) => {
              if (i in loadOptions && this.isNotEmpty(loadOptions[i]))
                  params = params.set(i, JSON.stringify(loadOptions[i]));
          });
          const page = (Number(params.get('skip'))/Number(params.get('take')))+1;
          params = params.set('texto', this.buscarTxt);
          params = params.set('page', page.toString());
          params = params.set('cod_departamento', this.departamento);
          return this.service.getProyectosGeneral(params)
        }
    });
  }

  active(boton){
    this.boton1 = 'normal';
    this.boton2 = 'normal';
    if(boton == 'boton1'){
      this.boton1 = 'default';
    }
    if(boton == 'boton2'){
      this.boton2 = 'default';
    }
  }

  paginaInicio(){
    this.buscarSw = false;
    this.buscarSwGeneral = false;
    this.active('');
  }

  buscarProyectos(){
    this.buscarSw = true;
    this.buscarSwGeneral = false;
    this.buscarTxt = '';
    this.filtrar();
    this.active('boton2');
    this.service.getListaReportesPorOpcion('2').then(data => {
      this.listaReportes = data.data
    });
  }

  buscarProyectosGeneral(){
    this.buscarSwGeneral = true;
    this.buscarSw = false;
    this.buscarTxt = '';
    this.filtrarGeneral();
    this.active('boton1');
    this.service.getListaReportesPorOpcion('1').then(data => {
      this.listaReportes = data.data
    });
  }

  onFormSubmit(e) {
    this.loadingVisible = true;
    let itemStr = localStorage.getItem('auth');
    itemStr = JSON.parse(itemStr);
    let editPassword = new EditPassword();
    editPassword.token = itemStr['token'];
    editPassword.password = this.password;
    editPassword.new_password = this.newPassword;
    this.service.editPassword(editPassword).subscribe(response => {
      this.loadingVisible = false;
      if(response.codigo==1) {
        notify({
          message: response.mensaje,
          position: {
              my: "center top",
              at: "center top"
          }
        }, "success", 3000);
        this.popupVisible = false;
      } else {
        notify({
          message: response.mensaje,
          position: {
              my: "center top",
              at: "center top"
          }
        }, "error", 3000);
      }
    });


    e.preventDefault();
  }
  changePassword() {
    this.popupVisible = true;
  }
  passwordComparison = () => {
    return this.newPassword;
  };
  logout() {
    let itemStr = localStorage.getItem('auth');
    itemStr = JSON.parse(itemStr);
    this.loadingVisible = true;
    this.service.logout(itemStr['token']).subscribe(reponse => {
      this.loadingVisible = false;
      localStorage.removeItem('auth');
      this._auth = false;
    });
  }
  auth(event) {
    this._auth = true;
    const now = new Date()
  	const item = {
      value: 'auth',
      token: event.token,
		  expiry: Math.floor(Date.now() / 1000) + 7200,
	  }
	  localStorage.setItem('auth', JSON.stringify(item));
  }
  onHidden() {
    this.password = '';
    this.newPassword = '';
    this.popupVisible = false;
  }
  loadData(e) {
    this.service.addBreadcrumb({name: `${e.title.text}`, param: 1});
    this.hiddenReport = true;
    this.showAppData = true;
    this.hiddenAppData = false;
    this.type = e.data._type;
    this.urlData = e.data.url;
  }
  loadData2(e) {
    this.service.addBreadcrumb({name: e.registro, param: 2});
    this.showProjectData = true;
    this.hiddenAppData = true;
    this.hiddenProjectData = false
    this.urlDataProject = e.url_proyectos;
  }
  update(item) {
    this.breadcrumbs=[];
    this.service.updateBreadcrumb(item.param);
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/report/report.component.ts